import React, { useEffect, useState } from "react";
import List from "./list";
import {
  Autocomplete,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import getArticleService from "../../../services/getArticleService";
import getClientService from "../../../services/getClientService";
import getJournalService from "../../../services/getJournalService";
import { useLocation, useNavigate } from "react-router-dom";

const ClientArticle = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [getdata, setGetData] = useState([]);
  const [client, setClient] = useState([]);
  const [journals, setJournals] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [filterVal, setFilterVal] = useState({
    pageNumber: 1,
    pageSize: 10,
    searchText: "",
    status: "",
    id: "",
    PublicationId: "",
    totalPages: 1,
  });
  const { pageNumber, pageSize, searchText, status, id, PublicationId } =
    filterVal;
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const urlStatus = params.get("status");
  const computedStatus = urlStatus
    ? urlStatus.charAt(0).toUpperCase() + urlStatus.slice(1)
    : filterVal.status;

  const fetchData = async (customFilterVal = filterVal) => {
    try {
      console.log("filter", customFilterVal);
      const list = await getArticleService.getArticleByUserId({
        ...customFilterVal,
      });
      setFilterVal((prev) => ({ ...prev, totalPages: list.totalPages }));
      setGetData(list?.articles || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    setFilterVal((prev) => {
      const newVal = {
        ...prev,
        status: computedStatus,
      };
      fetchData(newVal);
      return newVal;
    });
    // eslint-disable-next-line
  }, [computedStatus, pageNumber, pageSize, id, searchText, PublicationId]);

  useEffect(() => {
    // Check for status param in URL
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    if (statusParam) {
      setFilterVal((prev) => ({ ...prev, status: statusParam.charAt(0).toUpperCase() + statusParam.slice(1) }));
    }
    // eslint-disable-next-line
  }, []);

  const fetchCleint = async () => {
    try {
      const list = await getClientService.GetClientList(filterVal);
      console.log("filterlist", list);

      setClient(list); // Set the data to state currentPage
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    fetchCleint();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setFilterVal((prev) => ({
        ...prev,
        searchText: searchTerm,
        pageNumber: 1,
      }));
    }, 400); // ✅ Wait 400ms before making an API call

    return () => clearTimeout(delayDebounce); // ✅ Clear timeout if user keeps typing
  }, [searchTerm]); // ✅ Runs only when searchTerm changes

  const fetchJournals = async () => {
    try {
      const list = await getJournalService.GetAllJournal();
      console.log("journallist", list);
      setJournals(list || []);
    } catch (error) {
      console.error("Error fetching journals:", error);
    }
  };

  useEffect(() => {
    fetchJournals();
  }, []);

  const handleChange = (event) => {
    console.log(event.target.value);
    setFilterVal({ ...filterVal, id: event.target.value });
  };
  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    if (urlStatus !== null) {
      params.set("status", newStatus);
      navigate({ search: params.toString() }, { replace: true });
    } else {
      setFilterVal((prev) => ({
        ...prev,
        status: newStatus,
      }));
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleJournalChange = (event) => {
    console.log(event.target.value);
    setFilterVal({ ...filterVal, PublicationId: event.target.value });
  };

  return (
    <div>
      <h3 style={{ margin: "10px" }}>Invoice List</h3>
      <div className="my-3 d-flex justify-content-between">
        <div>
          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <Select
              labelId="client-select-label"
              name="client"
              displayEmpty
              value={id}
              onChange={handleChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 350,
                  },
                },
              }}
            >
              <MenuItem value="">All</MenuItem>
{/*
  {[...client]
    .sort((a, b) => a.first_name.localeCompare(b.first_name))
    .map((c) => (
      <MenuItem key={c.id} value={c.id}>
        {`${c.first_name} ${c.last_name}`}
      </MenuItem>
    ))}
*/}
              {[...client]
                .sort((a, b) =>
                  String(a.first_name ?? '').localeCompare(String(b.first_name ?? ''))
                )
                .map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {`${c.first_name ?? ''} ${c.last_name ?? ''}`.trim()}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <Select
              labelId="journal-select-label"
              name="journal"
              displayEmpty
              value={PublicationId}
              onChange={handleJournalChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 350,
                  },
                },
              }}
            >
              <MenuItem value="">All Publications</MenuItem>
              {[...journals]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((j) => (
                  <MenuItem key={j.id} value={j.id}>
                    {j.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <Select
              labelId="demo-simple-select-label"
              name="status"
              displayEmpty
              value={computedStatus}
              onChange={handleStatusChange}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="Pending">Pending Paymemt</MenuItem>
              <MenuItem value="Confirmed">Confirmed Paymemt</MenuItem>
              <MenuItem value="Unconfirmed">Unconfirmed Paymemt</MenuItem>
            </Select>
          </FormControl>
        </div>
        <FormControl
          sx={{ m: 1, width: "25ch" }}
          variant="outlined"
          size="small"
        >
          <InputLabel htmlFor="outlined-adornment-password">Search</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type="text"
            placeholder="Search By Id"
            name="search"
            value={filterVal.search}
            onChange={handleSearchChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" edge="end">
                  <Search />
                </IconButton>
              </InputAdornment>
            }
            label="search"
          />
        </FormControl>
      </div>
      <List
        getdata={getdata}
        filterVal={filterVal}
        setFilterVal={setFilterVal}
        fetchData={fetchData}
      />
    </div>
  );
};

export default ClientArticle;
